// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kGpu","content":"styles_content__2-u0k","tableWrap":"styles_tableWrap__2wPT2"};